export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        parseConfigValue(value,config) {
          let label=''
          config.forEach(v=>{
            if(value===v.value){
              label=v.label
            }
          })
          return label
        }
      }

    })
  }
}
